import UploadResume from './UploadResume'
export default UploadResume
